import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDateInput from '@core/components/AppDateInput.vue'
import { ClientChoiceOptions } from '@master/model/options/ClientChoiceOptions'

@Component({
  components: {
    AppDateInput
  }
})
export class TheClientChoiceTRMixin extends Vue {
  @Prop() targetModel
  @Prop() reviewDate
  @Prop() trKey
  @Prop() clientName
  @Prop() disabledDateSelection
  @Prop({ default: false }) private combinedColumn
  @Prop() options
  @Prop({ default: true }) dateApplicationOn: boolean

  getDataTestId (trKey, keyName) {
    return `rcmd-${trKey}-${keyName}`
  }

  get clientChoiceOptions () {
    return this.options ?? ClientChoiceOptions
  }

  get shouldDisabledDateSelection () {
    return this.disabledDateSelection ?? false
  }
}
